function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m314.882 460.564c5.893-7.552 5.965-18.151 0-25.795-1.349-1.73 2.694 2.442-44.366-44.618-8.201-8.201-21.498-8.201-29.699 0-8.2 8.201-8.2 21.498 0 29.698l6.818 6.817h-34.635c-11.598 0-21 9.402-21 21s9.402 21 21 21h34.635l-6.818 6.817c-13.269 13.27-3.688 35.851 14.85 35.849 5.374 0 10.749-2.051 14.85-6.151 47.439-47.438 43.103-42.998 44.365-44.617z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m405 0h-298.667c-11.598 0-21 9.402-21 21v426.667c0 11.598 9.402 21 21 21h21.333c11.598 0 21-9.402 21-21 0-59 48-107 107-107s107 48 107 107c0 11.598 9.402 21 21 21h21.334c11.598 0 21-9.402 21-21v-426.667c0-11.598-9.403-21-21-21zm-192 85.333h85.334c11.598 0 21 9.402 21 21s-9.402 21-21 21h-85.334c-11.598 0-21-9.402-21-21s9.402-21 21-21zm106.667 127.334h-128c-11.598 0-21-9.402-21-21s9.402-21 21-21h128c11.598 0 21 9.402 21 21s-9.403 21-21 21z"
});

var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.333 511.333",
    height: 512,
    viewBox: "0 0 511.333 511.333",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.0be0cd83.svg";
export { ForwardRef as ReactComponent };